import { call, put } from 'redux-saga/effects';

import {
  axiosNoAuthInstance,
  API_END_POINTS,
} from 'api';

import {
  PAGE_RECEIPTS,
  LOADING,
} from '../actionTypes';

const fetchPageReceipts = async gid => axiosNoAuthInstance.get(`${API_END_POINTS.PAGE_RECEIPTS}/${gid}`);

export function* getPageReceipts(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchPageReceipts, action.payload);
    yield put({ type: PAGE_RECEIPTS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: PAGE_RECEIPTS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}
